import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { AdInterface, appState, AppStateInterface } from '../../../../constants/app-state';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';

@Component({
  selector: 'arm-message-text',
  templateUrl: './message-text.component.html',
  styleUrls: ['./message-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageTextComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription = new Subscription();

  public formGroup: FormGroup;

  @ViewChild('messageText') messageText: ElementRef;

  constructor(private fb: FormBuilder,
              private cd: ChangeDetectorRef,
              private router: Router) {

  }

  public saveText(): Observable<any> {

    if (this.formGroup.invalid) { return of(null); }

    return new Observable((observer) => {

      const appStateCopy: AppStateInterface = appState.getValue();

      if (!appStateCopy.multipleChatsMessage) {
        appStateCopy.multipleChatsMessage = new BehaviorSubject({
          text: this.formGroup.controls.messageText.value,
          files: [],
        });

        appState.next(appStateCopy);

        observer.next(appStateCopy.multipleChatsMessage);
      } else {

        const multipleChatsMessageCopy: any = appStateCopy.multipleChatsMessage.getValue();
        multipleChatsMessageCopy.text = this.formGroup.controls.messageText.value;

        appStateCopy.multipleChatsMessage.next(multipleChatsMessageCopy);

        observer.next(appStateCopy.multipleChatsMessage);
      }
    })
  }

  public nextStep(): void {
    this.subscriptions.add(
      this.saveText()
        .subscribe((value: AdInterface) => {
          if (!value) { return; }

          this.router.navigate(['management-company/chats/message-file']);
        })
    );
  }

  public ngOnInit(): void {

    appState.getValue().progressBar.next({
      show: true,
      value: 100 / 4 * 2,
    });

    this.formGroup = this.fb.group({
      messageText: ['', [Validators.required, Validators.max(300)]],
    });

    this.cd.detectChanges();
  }

  public ngOnDestroy(): void {
    appState.getValue().progressBar.next({
      show: false,
      value: 0,
    });

    this.subscriptions.unsubscribe();
  }
}
